module.exports = __webpack_public_path__ + "static/media/Artboard5.081bdc17.png";